import api from './api'
import type { ApiResponse } from '../types'

// ================================================================================
// RISK CHECKER SERVICE — public, strictly non-diagnostic "Am I at Risk?" tool.
// GET /risk-checker/factors returns a localised risk-factor catalog; POST
// /risk-checker/assess returns an educational advisory band + guidance on
// whether to seek a health worker's advice. It NEVER diagnoses TB and never
// measures actual risk. No medicine/drug information is referenced.
// ================================================================================

export interface RiskFactor {
  id: string
  label: string
  description?: string
  highImpact: boolean
}

export type RiskFactorLevel = 'NONE' | 'LOW' | 'MODERATE' | 'HIGH'

export interface RiskAction {
  label: string
  type: 'LINK' | 'CALL'
  /** Router path for LINK actions. */
  path?: string | null
  /** tel: href for CALL actions. */
  href?: string | null
}

export interface RiskAssessment {
  riskLevel: RiskFactorLevel
  riskLabel: string
  summary: string
  recommendation: string
  disclaimer: string
  selectedFactors: string[]
  actions: RiskAction[]
}

/** Localised selectable risk-factor catalog. */
export async function getRiskFactors(): Promise<RiskFactor[]> {
  const res = await api.get<ApiResponse<RiskFactor[]>>('/risk-checker/factors')
  return res.data.data
}

/**
 * Submit the user's selected risk-factor ids and receive a non-diagnostic
 * educational advisory result. Empty array = nothing selected.
 */
export async function assessRisk(factorIds: string[]): Promise<RiskAssessment> {
  const res = await api.post<ApiResponse<RiskAssessment>>('/risk-checker/assess', { factorIds })
  return res.data.data
}